import { PlayerRole } from "../redux/players/playersSlice";

export const getPlayerRoleLabel = (
  playerRoleId: number,
  playerRoles: PlayerRole[],
  shortName?: boolean,
) => {
  return shortName
    ? playerRoles.find((arch) => arch.id === playerRoleId)?.shortName
    : playerRoles.find((arch) => arch.id === playerRoleId)?.name;
};
